"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.focusPreviousTab = exports.focusNextTab = void 0;
// Based on 'util/focusElement' and 'util/focus'
var focusNextTab = function focusNextTab(root, reverse) {
  var elements = root.querySelectorAll('button:not([disabled])');
  elements = Array.prototype.slice.call(elements);
  if (!elements.length) {
    return undefined;
  }
  var current = 0;
  for (; current < elements.length; current += 1) {
    if (typeof document !== 'undefined' && document.activeElement === elements[current]) {
      if (reverse) {
        current -= 1;
      } else {
        current += 1;
      }
      break;
    }
  }

  // Focuses the next/previous element in the array,
  // looping back to the beginning/end when necessary.
  var newSelectedTab = elements[(current + elements.length) % elements.length];
  newSelectedTab.focus();
  return newSelectedTab;
};
exports.focusNextTab = focusNextTab;
var focusPreviousTab = function focusPreviousTab(root, reverse) {
  if (reverse === void 0) {
    reverse = true;
  }
  return focusNextTab(root, reverse);
};
exports.focusPreviousTab = focusPreviousTab;